import { Button, ButtonRow, FormTextAreaInput, HeadingRow } from "cai-fusion"
import { useSiftV2 } from "../../../contexts/siftV2Context";
import { useEffect, useState } from "react";
import ContentRenders from "../../../../symphony/components/Chat/ChatEntry/ContentRenders";

const SiftOpportunityOverviewBlock = () => {

    const { currOpp, updateFields } = useSiftV2();

    const [isEditing, setIsEditing] = useState(false);
    const [formValue, setFormValue] = useState("");

    const [overviewObj, setOverviewObj] = useState({})

    useEffect(() => {
        if (isEditing) {
            setFormValue(overviewObj.answers[0]?.text ?? "");
        }
    }, [isEditing])

    useEffect(() => {
        if(currOpp?.request?.currentState?.form?.questions?.length > 0) {
            let overviewObj = currOpp?.request?.currentState?.form?.questions?.find((question) => question.questionText === "Opportunity Overview")
            setOverviewObj(overviewObj);
        }
    }, [currOpp])

    const onInputChange = (value) => {
        setFormValue(value);
    }

    const onSubmit = () => {
        updateFields([{...overviewObj, "answers": [{...overviewObj.answers[0], "text": formValue}, ...overviewObj.answers.slice(1)]}]);
    }

    return (
        <div className="o-block">
            <div className="row">
                <div className="col-12">
                    <HeadingRow 
                        isSecondary
                        title="Opportunity Overview"
                        size={3}
                    >
                        <ButtonRow>
                            {!isEditing && <Button 
                                outline
                                children="Edit"
                                size="small"
                                // onClick={() => show('EditOpportunityOverviewDrawer')}
                                onClick={() => setIsEditing(!isEditing)}
                            />}
                        </ButtonRow>
                    </HeadingRow>
                </div>
            </div>
            <div className="row l-mt-xs">
                <div className="col-12">
                    {!isEditing && <ContentRenders content={(overviewObj?.answers ? overviewObj?.answers[0]?.text : "")} isUser={ false }/>}
                    {isEditing && <>
                        <FormTextAreaInput 
                            rows={20}
                            formValue={formValue}
                            onInputChange={(fieldId, value) => onInputChange(value)}
                        />
                        <ButtonRow>
                            <Button 
                                outline
                                children="Cancel"
                                onClick={() => setIsEditing(false)}
                            />
                            <Button 
                                children="Save"
                                onClick={() => {
                                    setIsEditing(false)
                                    onSubmit();
                                }}
                            />
                        </ButtonRow>
                    </>}
                </div>
            </div>
        </div>
    )
}

export default SiftOpportunityOverviewBlock;